// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"849":"f21fcd51","888":"98e2d21d","989":"d35a466c"}[chunkId] || chunkId) + "." + {"31":"5884929ead30add5","121":"0cc17b0b283e0185","479":"1db084c4e1f88624","559":"8483398cfb114bab","849":"e188a1b658c136ed","888":"4e12fde925a9a5a8","967":"6e77a27c476635dc","989":"54986a7749a7a658"}[chunkId] + ".js";
};